module.exports = __webpack_public_path__ + "img/eu_logo.09cfc488.svg";